import { ClearCardRegistered, RegisterMode } from '@app/dev/actions/terminal';
import { PopupContext } from '@app/dev/contexts/popup';
import { useTranslation } from '@common/hooks/translation';
import React, { useState, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './style.scss';
import KeyboardFormField from '@common/components/keyboardFormField';
import { confirmation } from './helpers/confirmation';
import { fields } from './constants/fields';

const RegisterByCNPPopup = () => {
  const { isAdminLoggedIn, isCardRegistered } = useSelector((state) => state.terminal);

  const t = useTranslation();
  const [{ closePopup }] = useContext(PopupContext);
  const dispatch = useDispatch();

  const [form, setForm] = useState({
    Name: '',
    Surname: '',
    CNP: '',
    Phone: '',
    Email: '',

    checked: false,
  });

  const [errors, setErrors] = useState({});

  const onChange = (name, value) => {
    setForm({ ...form, [name]: value });

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: undefined,
    }));
  };

  const validateForm = () => {
    let isValid = true;
    const newErrors = {};

    fields.forEach((field) => {
      const { fieldName, isFieldValid, errorMessage } = field;
      const value = form[fieldName];

      if (!isFieldValid(value)) {
        isValid = false;
        newErrors[fieldName] = errorMessage;
      }
    });

    setErrors(newErrors);

    return isValid;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (validateForm()) {
      confirmation(form, isCardRegistered);
    }
  };

  return (
    <form className="popup-content popup-small">
      <h3 className="popup-title">{t('Registration')}</h3>
      <div className="popup-main-content">
        <div className="input-wrapper">
          <div className="popup-txt">{t('RFID')}</div>
          <div className="header-input-case">
            <input type="text" className="popup-inp" readOnly value={isCardRegistered.id} />
          </div>
        </div>
        <div className="input-wrapper">
          {fields.map((item) => (
            <KeyboardFormField
              key={item.name}
              name={item.fieldName}
              value={form[item.name]}
              onChange={(value) => onChange(item.name, value)}
              errorMessage={errors[item.fieldName]}
            />
          ))}
        </div>
        <div className={`input-wrapper-checkbox ${form.checked ? 'active' : ''}`}>
          <label htmlFor="checkbox" className="register-checkbox-item">
            <input id="checkbox" type="checkbox" className="register-checkbox" onChange={() => onChange('checked', !form.checked)} />

            <span className="agree-txt">
              {t('I agree with the')}
              &nbsp;
              <span className="marked-text">{t('GDPR TERMS')}</span>
              &nbsp;
              {t('of the provided by the state')}
            </span>
          </label>
        </div>
        {!isAdminLoggedIn && (
          <div className="register-info">
            <i className="global-icon icon-login-admin register-admin-icon" />
            <div className="admin-check">{t('Please ask administration for confirmation')}</div>
          </div>
        )}
      </div>
      <div className='popup-actions'>
        <button
          type="button"
          onClick={() => {
            closePopup();
            dispatch(RegisterMode(false));
            dispatch(ClearCardRegistered());
          }}
          className={`popup-cancel-button ${!isAdminLoggedIn ? 'register-cancel' : ''}`}
        >
          {t('Cancel')}
        </button>
        {!!isAdminLoggedIn && (
          <button
            disabled={!form.checked}
            type="button"
            onClick={handleSubmit}
            className="popup-confirm-button"
          >
            {t('Continue')}

          </button>
        )}
      </div>
    </form>
  );
};

export default RegisterByCNPPopup;
